import React, { useEffect, useMemo } from 'react';
import ResidualValueGridGeneralDataContainer from './ResidualValueGridGeneralDataContainer';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import FlexBox from 'components/common/FlexBox';
import ResidualValueGridStateContainer from './ResidualValueGridStateContainer';
import ResidualValueGridItemDetailsContainer from './details/ResidualValueGridItemDetailsContainer';
import { detailsLoadedItemIdsVar, highlightedItemIdVar, isAssetLevelResidualValuesVar, isGridEditableVar } from '../variables';

const ResidualValueGridContainer = () => {
  const match = useRouteMatch();

  const id = useMemo(() => match.params.id && getInt(match.params.id), [match]);

  // Reset variables when leaving edit page
  useEffect(
    () => () => {
      isGridEditableVar(null);
      highlightedItemIdVar(null);
      isAssetLevelResidualValuesVar(null);
      detailsLoadedItemIdsVar([]);
    },
    []
  );

  return (
    <FlexBox direction='column'>
      <ResidualValueGridGeneralDataContainer id={id} />
      {id && <ResidualValueGridItemDetailsContainer id={id} />}
      {id && <ResidualValueGridStateContainer id={id} />}
    </FlexBox>
  );
};

export default ResidualValueGridContainer;
